import { BorderType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  mobileBackgroundColorCss,
  mobileTextCss,
  TextProps,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface ContentBoxHeaderUiProps extends TextProps {
  backgroundColor?: string
  mobileBackgroundColor?: string
  borderRadius?: BorderType['radius']
  mobileBorderRadius?: BorderType['radius']
}

const ContentBoxHeaderUi = styled.div<ContentBoxHeaderUiProps>`
  padding: 10px;
  text-align: ${p => p.textAlign || 'start'};
  min-height: 50px;
  ${textCss}
  ${backgroundColorCss}
  ${p => p.theme.phone} {
    ${mobileTextCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
      ${mobileBackgroundColorCss}
    `}
`

export default ContentBoxHeaderUi
